export const core = {
  title: 'JUEGA',
  subtitle: 'GANA GIROS GRATIS',
  play: 'CASINO',
  more: '+ DE 10.000',
  footer: 'Copyright © 2025 interplay.tech - Todos los derechos reservados',
};
